import { useState, useMemo, useContext } from "react";
import usePaymentsActions from "../hooks/usePaymentsActions";
import { HotelContext } from '../context/hotel'
import { T } from "react-translator-component";
import { AdyenCheckout, Card, PayPal, GooglePay, ApplePay, Dropin, Twint } from '@adyen/adyen-web';
import '@adyen/adyen-web/styles/adyen.css';
import useSmartDebugLog from "../hooks/useSmartDebugLog";
import { isGemunder, isOffgrid } from "./CheckIn/hotelConditions";

export const Payment = ({ text, paymentDetail, paymentResult, checkoutRef, dropinInstance, setDropinInstance, countryCode, language = 'en-US' }) => {
    // useSmartDebugLog("Payment");

    const { data: hotel } = useContext(HotelContext);
    const [loading, setLoading] = useState(false)
    const [paymentCalled, setPaymentCalled] = useState(false);
    const [hasResult, setHasResult] = useState(null)
    const [hasError, setHasError] = useState("")

    const { sendPayment, paymentEvent } = usePaymentsActions()

    let internalId = null;

    let _clientKey = 'test_MW2GQ44S2VGYXNSZDK52HLAZTIW73AQB';
    let _environment = "test";
    console.log('PAYMENT - LIVE / TEST - 1 - hotel?.id', hotel?.id)
    if (process.env.REACT_APP_APP_ENV === 'prd') {
        _environment = "live";
        _clientKey = 'live_TXKPUEAYHNG2FAM53IVHRG3ZWEL5W4H5'     // hostz
        console.log('PAYMENT - LIVE / TEST - 2')
        if (hotel?.id === "9324d1b3-c49b-45fd-8a4e-d48bb5c48516") {     // GEMUNDER
            _clientKey = 'live_TZP7AH5IQNC5XHP2VDQQLIFQ6MK565EY'
            console.log('PAYMENT - LIVE / TEST - 3')
        }
        if (isOffgrid(hotel?.id)) {     // offgrid
            _clientKey = 'live_XEW4GYN3YNAX5DF52PQZFIE3OIO6D5MV'
            console.log('PAYMENT - LIVE / TEST - 3')
        }
    }

    const locale = useMemo(() => {
        let _locale = 'en-US';
        if (language === 'de') {
            _locale = 'de-DE';
        }
        if (language === 'fr') {
            _locale = 'fr-FR';
        }
        if (language === 'it') {
            _locale = 'it-IT';
        }
        if (language === 'es') {
            _locale = 'es-ES';
        }
        return _locale
    }, [countryCode, language])

    console.log('26ene - locale', locale);

    const showResult = (isError, detail) => {

        if (isError) {
            if (detail) {
                setHasError(detail);
            } else {
                setHasError("PAYMENT ERROR");
            }
            setHasResult(null);
            setPaymentCalled(false);
            paymentResult("Error", detail);
        } else {
            setHasError(null);
            setHasResult(detail);
            setPaymentCalled(false);
            paymentResult(detail, null);
        }
    }

    const cardConfig = {
        showPayButton: true, // Opcional: muestra el botón de pagar
        hasHolderName: true, // Permite ingresar el nombre del titular
        holderNameRequired: true, // Hace obligatorio el nombre del titular
    };

    let globalConfiguration = {
        session: {},
        environment: _environment,

        shopperLocale: locale,
        countryCode: countryCode,

        clientKey: _clientKey,
        paymentMethodComponents: {
            scheme: Card
        },
        onSubmit: async (state, dropin, actions) => {

            try {

                let payload = { ...state }

                if (paymentDetail.amounts) {
                    payload.amounts = paymentDetail.amounts;
                }
                if (paymentDetail.chargeDepositGuarantee) {
                    payload.chargeDepositGuarantee = true;
                }
                if (paymentDetail.onlyDepositGuarantee) {
                    payload.onlyDepositGuarantee = true;
                }
                if (paymentDetail.add_ons) {
                    payload.add_ons = paymentDetail.add_ons;
                }

                // Make a POST /payments request from your server.
                const result = await paymentEvent(internalId, "submit", payload);
                console.log('13feb - RRRR => ', result)
                // const result = await makePaymentsCall(state.data, countryCode, locale, amount);

                let _resultCode = result.resultCode || (result.status === true ? "Authorised" : "Error");

                // If the /payments request from your server fails, or if an unexpected error occurs.
                if (!_resultCode) {

                    console.log('000000001', _resultCode);
                    console.log('000000001', result);
                    showResult(true, null);

                    actions.reject();
                    return;
                }

                // const {
                //     resultCode,
                //     action,
                //     order,
                //     donationToken
                // } = result;

                // If the /payments request request form your server is successful, you must call this to resolve whichever of the listed objects are available.
                // You must call this, even if the result of the payment is unsuccessful.
                actions.resolve({
                    resultCode: _resultCode
                    // action,
                    // order,
                    // donationToken,
                });

                showResult(false, _resultCode);

            } catch (error) {
                console.log("onSubmit", error);
                console.log("Respuesta completa del servidor:", error.response || error);
                actions.reject();
            }


        },

        onPaymentCompleted: (result, component) => {
            console.log('PAYMENT - onPaymentCompleted', result);
            paymentEvent(internalId, "completed", result);
        },
        onPaymentFailed: (result, component) => {
            console.log('PAYMENT - onPaymentFailed', result);
            paymentEvent(internalId, "failed", result);
        },
        onError: (error, component) => {
            console.log('PAYMENT - onError', error);
            console.error(error.name, error.message, error.stack, component);
            showResult(true, error);
        },


        // onAdditionalDetails: (state, component) => {

        //     console.log('00000', state);

        //     // Envía los detalles adicionales al servidor
        //     fetch("/api/handleAdditionalDetails", {
        //         method: "POST",
        //         body: JSON.stringify(state.data),
        //         headers: {
        //             "Content-Type": "application/json",
        //         },
        //     })
        //         .then((response) => response.json())
        //         .then((data) => {
        //             // Maneja la respuesta del servidor
        //             if (data.resultCode === "Authorised") {
        //                 // Pago autorizado
        //             } else {
        //                 // Otro resultado
        //             }
        //         })
        //         .catch((error) => {
        //             console.error("Error al enviar detalles adicionales:", error);
        //         });
        // },
    };

    const handlePaymentClick = async (provider) => {

        if (dropinInstance) {
            dropinInstance.unmount(); // Desmontar el componente actual
        }

        setLoading(true);
        paymentResult("Loading", null);
        setPaymentCalled(true);
        setHasResult(null);
        setHasError("");

        const payload = {
            ...paymentDetail,
            countryCode: countryCode,
            locale: locale
        }
        console.log('PAYMENT - payload', payload);
        console.log('29ene - PAYMENT DETAIL', paymentDetail)
        const r = await sendPayment(payload);

        if (r) {
            console.log('13ene - r', r);

            // globalConfiguration.paymentMethodsResponse = r.paymentMethods;
            const _paymentMethods = {
                "paymentMethods": []
            }
            if (r?.paymentMethods?.paymentMethods) {
                r?.paymentMethods?.paymentMethods.map(pm => {
                    if (isGemunder(hotel?.id) && localStorage.getItem('all-payment-methods')) {
                        _paymentMethods.paymentMethods.push(pm)
                    } else {
                        if (pm.name === "Cards") {
                            _paymentMethods.paymentMethods.push(pm)
                        }
                    }
                })
            }
            globalConfiguration.paymentMethodsResponse = _paymentMethods

            globalConfiguration.session.id = r.id;
            globalConfiguration.session.sessionData = r.sessionData;
            globalConfiguration.locale = r.shopperLocale;
            internalId = r.internalId;

            globalConfiguration.paymentMethodsConfiguration = {
                scheme: {
                    // Configuración específica para tarjetas
                    showPayButton: true, // Muestra el botón de pagar
                    hasHolderName: true, // Permite ingresar el nombre del titular
                    holderNameRequired: true, // Hace obligatorio el nombre del titular
                    billingAddressRequired: false, // Opcional: dirección de facturación
                },
            }

            console.log('globalConfiguration', globalConfiguration);

            try {

                // const checkout = await AdyenCheckout({
                //     clientKey: globalConfiguration.clientKey,
                //     environment: globalConfiguration.environment,
                //     paymentMethodsResponse: [{"name":"AliPay","type":"alipay"},{"name":"AliPay","type":"alipay_wap"},{"brands":["amex","bcmc","cup","diners","discover","maestro","mc","visa"],"name":"Credit Card","type":"scheme"},{"brands":["amex","discover","maestro","mc","visa"],"configuration":{"merchantId":"000000000207957","merchantName":"apaleo GmbH"},"name":"Apple Pay","type":"applepay"},{"brands":["bcmc","maestro","mc","visa"],"name":"Bancontact card","type":"bcmc"},{"name":"Online bank transfer.","type":"directEbanking"},{"issuers":[{"id":"alandsbanken","name":"Ålandsbanken"},{"id":"saastopankki","name":"Säästöpankki"},{"id":"handelsbanken","name":"Handelsbanken"},{"id":"omasp","name":"Oma Säästöpankki"},{"id":"aktia","name":"Aktia"},{"id":"pop","name":"POP Pankki"},{"id":"spankki","name":"S-Pankki"},{"id":"danske","name":"Danske Bank"},{"id":"nordea-business","name":"NordeaBusiness"},{"id":"nordea","name":"Nordea"},{"id":"osuuspankki","name":"OP"}],"name":"Finnish E-Banking","type":"ebanking_FI"},{"issuers":[{"id":"1164","name":"SNS"},{"id":"1121","name":"Test Issuer"},{"id":"1154","name":"Test Issuer 5"},{"id":"1165","name":"iDeal Test Issuer"},{"id":"1153","name":"Test Issuer 4"},{"id":"1152","name":"Test Issuer 3"},{"id":"1163","name":"Ideal bridge test issuer"},{"id":"1151","name":"Test Issuer 2"},{"id":"1162","name":"Test Issuer Cancelled"},{"id":"1161","name":"Test Issuer Pending"},{"id":"1160","name":"Test Issuer Refused"},{"id":"1159","name":"Test Issuer 10"},{"id":"1158","name":"Test Issuer 9"},{"id":"1157","name":"Test Issuer 8"},{"id":"1156","name":"Test Issuer 7"},{"id":"1155","name":"Test Issuer 6"}],"name":"iDEAL","type":"ideal"},{"name":"Pay later with Klarna.","type":"klarna"},{"name":"Pay over time with Klarna.","type":"klarna_account"},{"name":"Pay now with Klarna.","type":"klarna_paynow"},{"name":"MobilePay","type":"mobilepay"},{"configuration":{"intent":"capture"},"name":"PayPal","type":"paypal"},{"configuration":{"merchantId":"50","gatewayMerchantId":"ApaleoGmbHCOM"},"name":"Google Pay","type":"paywithgoogle"},{"name":"Ratepay Invoice","type":"ratepay"},{"name":"Ratepay Direct Debit","type":"ratepay_directdebit"},{"name":"SEPA Direct Debit","type":"sepadirectdebit"},{"name":"TWINT","type":"twint"},{"name":"Vipps","type":"vipps"},{"name":"WeChat Pay","type":"wechatpayMiniProgram"},{"name":"WeChat Pay","type":"wechatpayQR"},{"name":"WeChat Pay","type":"wechatpaySDK"},{"name":"WeChat Pay","type":"wechatpayWeb"}],
                //     // paymentMethodComponents: {
                //     //     scheme: {
                //     //         // Configuration specific to cards
                //     //         showPayButton: true,
                //     //         hasHolderName: true,
                //     //         holderNameRequired: true,
                //     //         billingAddressRequired: false,
                //     //     }
                //     // },
                //     onSubmit: (state, dropin) => {
                //         makePayment(state.data);
                //     },
                //     onError: (error) => {
                //         console.error(error);
                //     },
                // });

                // const dropin = checkout.create('dropin').mount(checkoutRef.current);

                const checkout = await AdyenCheckout(globalConfiguration);

                const dropinConfiguration = {
                    // Required if you import individual payment methods.
                    paymentMethodComponents: [Card], // [Card, PayPal, GooglePay, ApplePay, Twint],
                    // Optional configuration.
                    onReady: () => { },
                    instantPaymentTypes: ['applepay', 'googlepay']
                };

                console.log('13nov - checkout', checkout)

                const dropin = new Dropin(checkout, dropinConfiguration).mount(checkoutRef.current);

                setDropinInstance(dropin); // Guardar la nueva instancia
                paymentResult("InProgress", null);
                setLoading(false);


            } catch (err) {
                setLoading(false);
                console.log('0000002', err);
                showResult(true, err);
            }

        } else {
            setLoading(false);
            console.log('0000003', 'err');
            showResult(true, null);
        }

    }

    return (
        <div>

            {(!checkoutRef && hasResult) && <p>{hasResult?.resultCode}</p>}
            {(!checkoutRef && hasError) && <p style={{ color: "#F00" }}>{hasError}</p>}

            {loading && (
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "200px" }}>
                    <p className="p-4 m-4 text-center">{T("payments.loading-component")}</p>
                </div>
            )}
            {!paymentCalled && <button className="px-1 mt-2 text-uppercase btn btn-primary btn-block btn-lg" onClick={handlePaymentClick}>{text}</button>}

        </div>
    )
}